const TOKEN_KEY = 'hotlistcasino_token';

export const getToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(TOKEN_KEY, token);
    window.dispatchEvent(new Event('auth:token'));
  }
};

export const clearToken = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(TOKEN_KEY);
    window.dispatchEvent(new Event('auth:token'));
  }
};
